import Joi from 'joi';

import { DurationUnitEnum } from '../../../../shared/enums/duration-unit.enum';

const reservationInfoPricingItemSchema = Joi.object({
  pricingItemPresetUuid: Joi.string().uuid().allow(null).optional(),
  pricingItemPresetId: Joi.number().integer().positive().allow(null).optional(),
  units: Joi.number().integer().min(0).allow(null).optional(),
}).or('pricingItemPresetUuid', 'pricingItemPresetId');

export const reservationInfoSchema = Joi.object({
  reservationUuid: Joi.string().uuid().allow(null).optional(),
  vehicleId: Joi.number().integer().positive().allow(null).optional(),
  vehicleUuid: Joi.string().uuid().allow(null).optional(),
  vehicleCategoryId: Joi.number().integer().positive().allow(null).optional(),
  vehicleCategoryUuid: Joi.string().uuid().allow(null).optional(),
  dateFrom: Joi.date().required(),
  dateTo: Joi.date().required(),
  agentUuid: Joi.string().uuid().allow(null).optional(),
  durationUnit: Joi.string()
    .valid(...Object.values(DurationUnitEnum))
    .default(DurationUnitEnum.DAY),
  pricingItems: Joi.array()
    .items(reservationInfoPricingItemSchema)
    .allow(null)
    .optional(),
}).or('vehicleId', 'vehicleUuid', 'vehicleCategoryId', 'vehicleCategoryUuid');
